module.exports = __webpack_public_path__ + "static/media/game-interviewer12.9447fd59.png";